import React from "react";
import parseEligibilitySearch from "./LegacyTransforms";
import RequestTable from "../components/RequestTable";
import { COLUMNS_CPT, COLUMNS_MAXIMUMS } from "utils/constants";

function RequestFormParser({ json }) {
  const parseJson = (originalJson) => {
    if (!originalJson) {
      return null;
    }
    try {
      const parsedJson = parseEligibilitySearch(originalJson);

      if (!parsedJson || !Array.isArray(parsedJson)) {
        return null;
      }
      return formatHTML(parsedJson);
    } catch (error) {
      console.error("Error parsing eligibility search JSON:", error);
      return null;
    }
  };

  const formatHTML = (parsedJson) => {
    if (!parsedJson || !Array.isArray(parsedJson)) {
      return null;
    }
    return parsedJson.map((section_outer, outerIndex) => {
      if (!section_outer || !Array.isArray(section_outer) || section_outer.length === 0) {
        return null;
      }
      let item = section_outer[0]; // item is always array of 1
      if (!item) {
        return null;
      }
      if (item.title === "claims_info") {
        // one table for each set of claims
        var requestTables = [];
        console.log(item.groups);
        if (!item.groups || item.groups.length === 0) {
          return null;
        }
        item.groups.forEach((group) => {
          // each group is always array of 1
          if (!group || !group[0] || !group[0].data || !group[0].columns) {
            return; // skip invalid groups
          }
          requestTables.push(<RequestTable
            title={'Claim ' + (requestTables.length + 1)}
            data={[group[0].data]}
            columns={group[0].columns}
          />)
        });
        return requestTables.length > 0 ? requestTables : null;
      }
      //Check if there are groups
      if (item["groups"] !== undefined) {
        // Safety check for empty groups array
        if (!item.groups || item.groups.length === 0 || !item.groups[0] || !item.groups[0][0]) {
          return null;
        }
        if (item.groups[0][0].data !== undefined) {
          // if there is just one level of group, gather all the data under one header and set of columns
          const groupData = [];
          item.groups.forEach((group) => {
            groupData.push(group[0].data);
          });
          return (
            <RequestTable
              title={item.title.split("_").join(" ")}
              data={groupData}
              columns={item.groups[0][0].columns}
            />
          );
        } else {
          // if there are multiple levels of groups, map the data for each group into a table
          return item.groups.map((group) => {
            const originalCols = group[1][1][0].columns;
            const groupColumns = [];
            originalCols.forEach((key) => {
              // Don't exclude any columns - include all of them
              let temp = key;
              COLUMNS_CPT.forEach((val) => {
                if (key.accessor === val.accessor) {
                  temp = val;
                }
              });
              groupColumns.push(temp);
            });
            return (
              <RequestTable
                title={group[1][0][0].procedure_code_group_name}
                data={group[1][1][0].data}
                columns={groupColumns}
              />
            );
          });
        }
      } else {
        // If there are no groups, check if we need to add $ signs
        const originalCols = item.columns;
        const groupColumns = [];
        originalCols.forEach((key) => {
          let temp = key;
          COLUMNS_MAXIMUMS.forEach((val) => {
            if (key.accessor === val.accessor) {
              temp = val;
            }
          });
          groupColumns.push(temp);
        });
        return (
          <RequestTable
            title={item.title}
            data={[item.data]}
            columns={groupColumns}
          />
        );
      }
    });
  };

  try {
    const parsed = parseJson(json);
    if (!parsed) {
      return null;
    }
    return <>{parsed}</>;
  } catch (renderError) {
    console.error("Error rendering RequestFormParser:", renderError);
    return null;
  }
}

export default RequestFormParser;
